import { GridApiPro } from "@mui/x-data-grid-pro";
import AcxButton from "components/UI/AcxButton";
import React from "react";
import AcxDataGridStore from "../AcxDataGridStore";

interface IFilterIcon {
    onClick: () => void;
    vertIconEnabled: boolean;
    store: AcxDataGridStore;
    gridApiRef?: React.MutableRefObject<GridApiPro>;
    isFiltered?: boolean;
}

const FilterIcon = React.forwardRef<HTMLDivElement, IFilterIcon>(
    (props: IFilterIcon, ref) => {
        return (
            <div ref={ref}>
                <AcxButton
                    disabled={props.store.rows.length < 1}
                    onClick={props.onClick}
                    color="white"
                    sx={(theme) => ({
                        marginRight: props.vertIconEnabled
                            ? theme.spacing(1)
                            : 0,
                    })}
                >
                    Filter
                </AcxButton>
            </div>
        );
    },
);

export default FilterIcon;
